import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { getDisplayDomain } from '../utils/url';
interface CaseWebsiteLinkProps {
  url: string;
  clientName: string;
  className?: string;
}

// Kleine secundaire link naar de live website van een klant.
// Toont het domein zonder https, opent in een nieuw tabblad.
export const CaseWebsiteLink: React.FC<CaseWebsiteLinkProps> = ({
  url,
  clientName,
  className = ''
}) => {
  return <a href={url} target="_blank" rel="noopener noreferrer" aria-label={`Bekijk de website van ${clientName} (opent in nieuw tabblad)`} className={`inline-flex items-center gap-1.5 min-w-0 text-sm text-[#6B7280] hover:text-[#004AC7] transition-colors duration-200 ${className}`} data-id="element-150" data-mp="28028rskol3px">
      <span className="truncate" data-id="element-151" data-mp="2lzbkaexxz9nk">{getDisplayDomain(url)}</span>
      <ExternalLinkIcon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" data-id="element-152" data-mp="3tc3ye7bgjqxm" />
    </a>;
};